export class CustomComboboxOptionWrapper<ItemType> {
  text?: string // deprecated
  callback?: (initiateNewItemCreation: () => void) => void // deprecated
  item: ItemType
  onSelect: (item: ItemType) => void

  constructor(
    item: ItemType,
    onSelect: (item: ItemType) => void,
    text?: string,
    callback?: (initiateNewItemCreation: () => void) => void
  ) {
    this.item = item
    this.onSelect = onSelect
    this.text = text
    this.callback = callback
  }
}
